if (!window.hasColorPreviewImage) {
  (function () {
    function getMap() {
      var script = document.getElementById('ColorPreviewImageMap');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
    }

    function applyValue(container, img, map, value) {
      var url = map[value];
      if (url) {
        img.src = url;
        img.alt = value;
        container.hidden = false;
      } else {
        container.hidden = true;
      }
    }

    function setup(swatchGroup, map) {
      if (swatchGroup.dataset.cpiInit === 'true') return;
      swatchGroup.dataset.cpiInit = 'true';

      var container = document.createElement('div');
      container.className = 'color-preview-image';
      container.hidden = true;

      var img = document.createElement('img');
      img.width = 150;
      img.height = 150;
      img.loading = 'lazy';
      container.appendChild(img);

      swatchGroup.parentNode.insertBefore(container, swatchGroup);

      var checkedInput = swatchGroup.querySelector('li.select-option input:checked');
      if (checkedInput) {
        var checkedLi = checkedInput.closest('li.select-option');
        if (checkedLi) applyValue(container, img, map, checkedLi.getAttribute('data-value'));
      }

      swatchGroup.addEventListener('change', function (event) {
        var target = event.target;
        if (!target || target.tagName !== 'INPUT') return;
        var li = target.closest('li.select-option');
        if (!li) return;
        applyValue(container, img, map, li.getAttribute('data-value'));
      });

      // Some swatch skins select on click on the label rather than firing a
      // native change event reliably; this is a harmless extra safety net.
      swatchGroup.addEventListener('click', function (event) {
        var li = event.target.closest && event.target.closest('li.select-option');
        if (!li) return;
        window.setTimeout(function () {
          applyValue(container, img, map, li.getAttribute('data-value'));
        }, 0);
      });
    }

    function scan() {
      var map = getMap();
      if (!map) return;

      var swatchGroups = document.querySelectorAll('.globo-swatch-list .swatch--gl[data-option-index="0"]');
      swatchGroups.forEach(function (group) {
        setup(group, map);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    // The Globo app can render its swatches asynchronously after the page
    // has loaded, so keep checking for a while in case they're not there
    // yet. setup() is safe to call more than once (guarded per element).
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      scan();
      if (attempts >= 20) clearInterval(interval);
    }, 500);
  })();

  window.hasColorPreviewImage = true;
}
